var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.184 2h-8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z",
    stroke: "inherit",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.184 2v6h6M16.184 13h-8M16.184 17h-8M10.184 9h-2",
    stroke: "inherit",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgDownload as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14.1836 2H6.18359C5.07902 2 4.18359 2.89543 4.18359 4V20C4.18359 21.1046 5.07902 22 6.18359 22H18.1836C19.2882 22 20.1836 21.1046 20.1836 20V8L14.1836 2Z' stroke='inherit' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M14.1836 2V8H20.1836' stroke='inherit' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M16.1836 13H8.18359' stroke='inherit' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M16.1836 17H8.18359' stroke='inherit' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M10.1836 9H9.18359H8.18359' stroke='inherit' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";